import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../i18n/LanguageContext';
export function CookiePolicyPage() {
  const {
    t
  } = useLanguage();
  return <div className="w-full bg-white min-h-screen pb-32" data-id="element-184">
      <div className="bg-corporate-dark text-white py-20 px-4" data-id="element-185">
        <div className="max-w-4xl mx-auto text-center mt-10" data-id="element-186">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="text-4xl md:text-5xl font-heading font-bold mb-6 tracking-tight" data-id="element-187">
            {t('footer.cookies')}
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.15
        }} className="text-lg text-gray-300 max-w-2xl mx-auto font-light" data-id="element-188">
            Información sobre el uso de cookies en nuestro sitio web y cómo
            gestionarlas.
          </motion.p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 mt-16" data-id="element-189">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="space-y-12" data-id="element-190">
          {/* Sección 1 */}
          <section data-id="element-191">
            <h2 className="text-2xl font-heading font-bold text-corporate-dark mb-4" data-id="element-192">
              1. ¿Qué son las Cookies?
            </h2>
            <div className="text-gray-600 font-light leading-relaxed space-y-4" data-id="element-193">
              <p data-id="element-194">
                Las cookies son pequeños archivos de texto que se almacenan en
                el dispositivo del usuario (ordenador, tablet o teléfono móvil)
                cuando visita un sitio web. Las cookies permiten que el sitio
                web recuerde información sobre su visita, como sus preferencias
                de idioma, configuración de visualización y otras opciones, lo
                que facilita su próxima visita y hace que el sitio sea más útil.
              </p>
              <p data-id="element-195">
                Las cookies desempeñan un papel muy importante y contribuyen a
                mejorar la experiencia de navegación del usuario.
              </p>
            </div>
          </section>

          {/* Sección 2 */}
          <section data-id="element-196">
            <h2 className="text-2xl font-heading font-bold text-corporate-dark mb-4" data-id="element-197">
              2. Tipos de Cookies que Utilizamos
            </h2>
            <div className="text-gray-600 font-light leading-relaxed space-y-6" data-id="element-198">
              <div data-id="element-199">
                <h3 className="text-lg font-heading font-semibold text-corporate-dark mb-2" data-id="element-200">
                  Cookies Técnicas o Necesarias
                </h3>
                <p data-id="element-201">
                  Son aquellas estrictamente necesarias para el funcionamiento
                  del sitio web. Permiten al usuario navegar por la página y
                  utilizar sus funcionalidades básicas, como acceder a áreas
                  seguras, recordar preferencias de idioma o mantener la sesión
                  activa. Sin estas cookies, el sitio web no puede funcionar
                  correctamente.
                </p>
              </div>

              <div data-id="element-202">
                <h3 className="text-lg font-heading font-semibold text-corporate-dark mb-2" data-id="element-203">
                  Cookies de Análisis
                </h3>
                <p data-id="element-204">
                  Son aquellas que nos permiten cuantificar el número de
                  usuarios, conocer las páginas más visitadas, analizar el
                  comportamiento de navegación y obtener información estadística
                  sobre el uso del sitio web. Esta información se recopila de
                  forma anónima y nos ayuda a mejorar el funcionamiento y los
                  contenidos del sitio.
                </p>
              </div>

              <div data-id="element-205">
                <h3 className="text-lg font-heading font-semibold text-corporate-dark mb-2" data-id="element-206">
                  Cookies de Preferencias
                </h3>
                <p data-id="element-207">
                  Permiten recordar las preferencias del usuario, como el idioma
                  seleccionado, la región desde la que accede o la configuración
                  de visualización. Estas cookies mejoran la experiencia
                  personalizada del usuario en el sitio web.
                </p>
              </div>

              <div data-id="element-208">
                <h3 className="text-lg font-heading font-semibold text-corporate-dark mb-2" data-id="element-209">
                  Cookies de Terceros
                </h3>
                <p data-id="element-210">
                  Este sitio web puede utilizar servicios de terceros que
                  instalan sus propias cookies en el dispositivo del usuario,
                  como herramientas de análisis web (por ejemplo, Google
                  Analytics) o plataformas de contenido integrado. SmartImport
                  Internacional no controla directamente estas cookies y
                  recomienda al usuario consultar las políticas de privacidad y
                  cookies de dichos terceros para obtener más información.
                </p>
              </div>
            </div>
          </section>

          {/* Sección 3 */}
          <section data-id="element-211">
            <h2 className="text-2xl font-heading font-bold text-corporate-dark mb-4" data-id="element-212">
              3. Gestión de Cookies
            </h2>
            <div className="text-gray-600 font-light leading-relaxed space-y-4" data-id="element-213">
              <p data-id="element-214">
                El usuario puede aceptar, rechazar o configurar las cookies en
                cualquier momento a través de la configuración de su navegador.
                A continuación se indican los pasos para gestionar las cookies
                en los navegadores más utilizados:
              </p>
              <ul className="list-disc pl-6 space-y-3" data-id="element-215">
                <li data-id="element-216">
                  <strong className="font-medium" data-id="element-217">Google Chrome:</strong>{' '}
                  Configuración → Privacidad y seguridad → Cookies y otros datos
                  de sitios.
                </li>
                <li data-id="element-218">
                  <strong className="font-medium" data-id="element-219">Mozilla Firefox:</strong>{' '}
                  Opciones → Privacidad y seguridad → Cookies y datos del sitio.
                </li>
                <li data-id="element-220">
                  <strong className="font-medium" data-id="element-221">Safari:</strong> Preferencias
                  → Privacidad → Gestionar datos de sitios web.
                </li>
                <li data-id="element-222">
                  <strong className="font-medium" data-id="element-223">Microsoft Edge:</strong>{' '}
                  Configuración → Cookies y permisos del sitio → Cookies y datos
                  almacenados.
                </li>
              </ul>
              <p data-id="element-224">
                Es importante tener en cuenta que la desactivación de
                determinadas cookies puede afectar al correcto funcionamiento de
                algunas funcionalidades del sitio web, como la selección de
                idioma o la navegación entre secciones.
              </p>
            </div>
          </section>

          {/* Sección 4 */}
          <section data-id="element-225">
            <h2 className="text-2xl font-heading font-bold text-corporate-dark mb-4" data-id="element-226">
              4. Consentimiento
            </h2>
            <div className="text-gray-600 font-light leading-relaxed space-y-4" data-id="element-227">
              <p data-id="element-228">
                Al acceder y navegar por este sitio web, el usuario consiente el
                uso de las cookies descritas en esta política, en los términos y
                condiciones aquí establecidos. El usuario puede retirar su
                consentimiento en cualquier momento modificando la configuración
                de cookies en su navegador.
              </p>
            </div>
          </section>

          {/* Sección 5 */}
          <section data-id="element-229">
            <h2 className="text-2xl font-heading font-bold text-corporate-dark mb-4" data-id="element-230">
              5. Actualización de esta Política
            </h2>
            <div className="text-gray-600 font-light leading-relaxed space-y-4" data-id="element-231">
              <p data-id="element-232">
                SmartImport Internacional puede actualizar esta Política de
                Cookies periódicamente para reflejar cambios en las cookies
                utilizadas o por motivos operativos, legales o regulatorios.
                Recomendamos al usuario revisar esta política regularmente para
                estar informado sobre el uso de cookies en nuestro sitio web.
              </p>
            </div>
          </section>

          <div className="border-t border-gray-200 pt-8 mt-12" data-id="element-233">
            <p className="text-sm text-gray-400 font-light" data-id="element-234">
              Última actualización: Marzo 2026
            </p>
          </div>
        </motion.div>
      </div>
    </div>;
}